import { HorizontalBar } from 'vue-chartjs'
 
export default {
	extends: HorizontalBar,
	data: function(){
		return {
	
			data : {
		            
				      datasets: [
				        {
				          label: 'Course Progression',
				          backgroundColor: ["#49a5a9"],
				          data: [38]
				        }
				      ]
              },
            options:{
	            /*onClick:function(evt){
	                var activePoints = this.getElementsAtEvent(evt);
		            var firstPoint = activePoints[0];
					var link = this.data.links[firstPoint._index];
					alert(link);
	            },*/
	            
	            responsive: true,
	            scales: {
			        xAxes: [{
			            ticks: {
			                beginAtZero: true,
			                min: 0,
			                max: 100
			            }
			        }]
			    },
	        }
        }
    },
	mounted () {
		
		
		
		this.renderChart(this.data, this.options);
	}
}


// WEBPACK FOOTER //
// ./src/components/charts/CourseProgressionChart.js